import { Component, OnInit } from "@angular/core";
import { Annotation } from "../../interfaces/annotation";
import { Project } from "../../interfaces/project";
import { ProjectService } from "../../services/project/project.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AnnotationService } from "../../services/annotation/annotation.service";
import { AnnotationtypeService } from "../../services/annotationtype/annotationtype.service";
import { environment } from "../../../environments/environment";
import { AnnotationvariantService } from "../../services/annotationvariant/annotationvariant.service";
import { Annotationvariant } from "../../interfaces/annotationvariant";

@Component({
  selector: "app-annotation-detail",
  templateUrl: "./annotation-detail.component.html",
  styleUrls: ["./annotation-detail.component.scss"],
})
export class AnnotationDetailComponent implements OnInit {
  env: any = environment;
  loading: boolean;
  annotation: Annotation;
  annotationtypesArray: Array<Object>;
  annotationtypes: Object;
  project: Project;
  currentAnnotationTypeId = 0;
  questions: string;
  timeoutId: any;
  variantIndexToDelete: number;

  constructor(
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private annotationService: AnnotationService,
    private annotationtypeService: AnnotationtypeService,
    private router: Router,
    private annotationvariantService: AnnotationvariantService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: { id: string }) => {
      this.loading = true;
      this.annotationService
        .getAnnotationByShortId(params.id)
        .then((annotation: Annotation) => {
          this.annotation = annotation;
          this.projectService
            .getProjectById(annotation.projectId)
            .then((project: Project) => {
              this.project = project;
              this.getAnnotationtypes();
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
            });
        })
        .catch((error) => {
          this.loading = false;
        });
    });
  }

  getAnnotationtypes() {
    this.annotationtypeService
      .getAnnotationtypesByVersion(this.project.version)
      .then((annotationtypes) => {
        // this.annotationtypesArray = Object.values(annotationtypes);
        this.annotationtypesArray = Object.keys(annotationtypes).map(
          (e) => annotationtypes[e]
        );
        this.annotationtypes = annotationtypes;
        if (this.annotation.types.length > 0)
          this.questions = this.annotationtypes[
            this.annotation.types[0]
          ].questions;
      });
  }

  createAnnotation() {
    this.loading = true;
    this.annotationService
      .createAnnotation({ projectId: this.project._id })
      .then((annotation: Annotation) => {
        this.loading = false;
        this.router.navigate(["/annotation-detail/" + annotation.shortId]);
      });
  }

  deleteAnnotation() {
    this.loading = true;
    this.annotationService
      .deleteAnnotationById(this.annotation._id)
      .then(() => {
        this.loading = false;
        this.router.navigate(["/annotations/" + this.project.shortId]);
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  saveVariant(variant) {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      // Runs 1 second (1000 ms) after the last change
      this.annotationvariantService.updateAnnotationvariant(variant);
    }, 500);
  }

  deleteVariant() {
    if (this.variantIndexToDelete) {
      this.loading = true;
      if (this.annotation.variants.length === 1) {
        this.deleteAnnotation();
      } else {
        const variant = this.annotation.variants[this.variantIndexToDelete];
        this.annotationvariantService
          .deleteAnnotationvariantById(variant._id)
          .then(() => {
            this.annotation.variants.splice(this.variantIndexToDelete, 1);
            this.loading = false;
            this.variantIndexToDelete = null;
          })
          .catch((error) => {
            this.loading = false;
            this.variantIndexToDelete = null;
          });
      }
    }
  }

  setVariantIndexToDelete(index) {
    this.variantIndexToDelete = index;
  }

  createVariant() {
    this.loading = true;
    const lastVariant = this.annotation.variants[
      this.annotation.variants.length - 1
    ];
    this.annotationvariantService
      .createAnnotationvariant({
        projectId: this.project._id,
        annotationId: this.annotation._id,
        stakeholder: lastVariant.stakeholder,
        description: lastVariant.description,
      })
      .then((variant: Annotationvariant) => {
        this.loading = false;
        this.annotation.variants.push(variant);
        $("html, body").animate({ scrollTop: $(document).height() }, "slow");
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  /**
   * deletes annotationtype with
   * @param index
   */
  deleteType(index) {
    this.annotation.types.splice(index, 1);
    this.updateAnnotation();
    this.refreshQuestion(this.annotation.types[0]);
  }

  /**
   * changes the actual question relating to actual first annotationtype
   * @param annotationtype
   */
  refreshQuestion(annotationtype) {
    if (this.annotationtypes[annotationtype])
      this.questions = this.annotationtypes[annotationtype].questions;
    else this.questions = "";
  }

  /**
   * opens the annotationtype selection-field
   * @param id
   */
  openSelection(modal, id) {
    this.currentAnnotationTypeId = id;
    modal.open();
  }

  updateAnnotation() {
    this.annotationService.updateAnnotation(this.annotation);
  }

  /** adds or changes the type of a specific annotationtype in the current annotation*/
  addAnnotationtype(annotationtype) {
    // if current annotationtype is not blank (blank == -1)
    if (this.currentAnnotationTypeId === 0) {
      if (annotationtype.name !== this.annotation.types[0]) {
        this.annotation.types[0] = annotationtype.name;
        this.updateAnnotation();
        this.refreshQuestion(annotationtype.name);
      }
    } else {
      // if its the first added type add the question to template
      if (!this.annotation.types[0]) {
        this.refreshQuestion(annotationtype.name);
      }
      // if selected type is already added change it to new type
      if (this.annotation.types[this.currentAnnotationTypeId]) {
        this.annotation.types[this.currentAnnotationTypeId] =
          annotationtype.name;
      }
      // else push new type to types
      else {
        this.annotation.types.push(annotationtype.name);
        this.updateAnnotation();
      }
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/annotation-detail/annotation-detail.component.ts